import { Component, OnInit } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { TiposServiciosService } from "../tipos-servicios.service";
import { TiposServicioDTO } from "src/app/models/tipo-servicio.dto";
import { CrudForm } from "src/app/components/shared/cruds/crud.form";

@Component({
  selector: "app-form-drawer-tipo-material",
  templateUrl: "./drawer-form.component.html",
})
export class TipoServiciosDrawerForm
  extends CrudForm<TiposServicioDTO>
  implements OnInit
{
  drawerRef: any;
  data?: {
    mode: "create" | "update";
    value: TiposServicioDTO;
  };
  constructor(
    public fb: FormBuilder,
    private service: TiposServiciosService,
  ) {
    super(fb);
  }
  public ngOnInit(): void {
    this.buildForm();
    if (this.data) {
      this.defaults = this.data.value;
      if (this.data.mode === "update") {
        this.setUpdate(this.data.value);
      } else {
        this.setCreate();
      }
    }
  }

  // TODO add validators
  public fromInit(row: TiposServicioDTO) {
    this.form.controls["IdTipoServicio"].setValue(row?.IdTipoServicio);
    this.form.controls["Descripcion"].patchValue(row?.Descripcion);
  }

  protected buildForm() {
    this.form = this.fb.group({
      IdTipoServicio: [""],
      Descripcion: [""],
    });
  }

  public saveOver() {
    this.drawerRef.close({
      valid: this.form.invalid,
      data: {
        mode: this.mode,
        value: this.form.value,
      },
    });
  }

}
